import { render, staticRenderFns } from "./VideoConference.vue?vue&type=template&id=6ee67a2e&scoped=true&"
import script from "./VideoConference.vue?vue&type=script&lang=js&"
export * from "./VideoConference.vue?vue&type=script&lang=js&"
import style0 from "./VideoConference.vue?vue&type=style&index=0&id=6ee67a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee67a2e",
  null
  
)

export default component.exports